"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferCVFromString = exports.bufferCV = void 0;
const common_1 = require("@stacks/common");
const clarityValue_1 = require("../clarityValue");
const bufferCV = (buffer) => {
    if (buffer.length > 1000000) {
        throw new Error('Cannot construct clarity buffer that is greater than 1MB');
    }
    return { type: clarityValue_1.ClarityType.Buffer, buffer };
};
exports.bufferCV = bufferCV;
const bufferCVFromString = (str) => bufferCV(common_1.Buffer.from(str));
exports.bufferCVFromString = bufferCVFromString;
//# sourceMappingURL=bufferCV.js.map